import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";

import { ContactRepresentativeSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import { CONTACT_REPRESENTATIVE_SEARCH_COLUMNS } from "./consts";

const ContactRepresentativeSearchResults: React.FC<ContactRepresentativeSearchResultsProps> = (props) => {
  const {
    data,
    isLoading,
    onRowClick,
    onPersonClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={CONTACT_REPRESENTATIVE_SEARCH_COLUMNS(t, onPersonClick, onDeleteClick)}
      data={data}
      selectableRows={false}
      disablePagination={true}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
};

export default memo(ContactRepresentativeSearchResults);
